import script from "./VoiceCallPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./VoiceCallPanel.vue?vue&type=script&setup=true&lang=ts"

import "./VoiceCallPanel.vue?vue&type=style&index=0&id=4c6a8764&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c6a8764"]])

export default __exports__